import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'
import type { UserData } from '@/features/iam/users/UserData'
import env from '@/infra/env'
import { PostHogTrackingService } from '@/features/tracking/PostHogTrackingService'
import { NoOpTrackingService } from '@/features/tracking/NoOpTrackingService'

export interface TrackingService {
  identify(member: WorkspaceMember, userData: UserData): void

  reset(): void
}

export function createTrackingService() {
  return env.POSTHOG_KEY
    ? PostHogTrackingService.create()
    : NoOpTrackingService.create()
}
